<template>
  <div class="product-details container-fluid">
    <div v-if="loading" class="text-center">
      <div class="spinner-grow text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-else>
      <div
        class="alert alert-danger product-item__content--edit__error"
        role="alert"
        v-if="errors.length > 0"
      >
        <p v-for="error in errors" :key="error">{{ error }}</p>
      </div>
      <hr style="width: 100%" />
      <div class="row">
        <product-edit-item
          :type="'Title (en)'"
          :name="product.title_en"
          :editProperty="'title_en'"
          :productId="product.productId"
        ></product-edit-item>

        <product-edit-item
          :type="'Title (ar)'"
          :name="product.title"
          :editProperty="'title'"
          :productId="product.productId"
        ></product-edit-item>
          <!-- v-if="$props.parentCategory.stock_type == 'fabric'" -->

        <product-edit-item
          :type="'Description (en)'"
          :name="product.sub_title_en"
          :editProperty="'sub_title_en'"
          :productId="product.productId"
        ></product-edit-item>
        <product-edit-item
          :type="'Description (ar)'"
          :name="product.sub_title"
          :editProperty="'sub_title'"
          :productId="product.productId"
        ></product-edit-item>
        <product-edit-item
          :type="'Price'"
          :name="product.price"
          :editProperty="'price'"
          :productId="product.productId"
          :product="product"
        ></product-edit-item>
        <product-edit-item
          :type="'Price Sale'"
          :name="product.sale_price"
          :editProperty="'sale_price'"
          :productId="product.productId"
          :product="product"
        ></product-edit-item>

        <product-edit-item
          :type="'SKU'"
          :name="product.sku"
          :editProperty="'sku'"
          :productId="product.productId"
        ></product-edit-item>
        <div class="col-md-6"></div>

        <product-edit-item
          v-if="$props.parentCategory.stock_type == 'fabric'"
          :type="'Type'"
          :name="product.type"
          :editProperty="'type'"
          :productId="product.productId"
          meta="true"
        ></product-edit-item>

        <product-edit-item
          v-if="$props.parentCategory.stock_type == 'fabric'"
          :type="'Type (en)'"
          :name="product.type_en"
          :editProperty="'type_en'"
          :productId="product.productId"
          meta="true"
        ></product-edit-item>

        <product-edit-item
          v-if="$props.parentCategory.stock_type == 'fabric'"
          :type="'Season'"
          :name="product.season"
          :editProperty="'season'"
          :productId="product.productId"
          meta="true"
        ></product-edit-item>

        <product-edit-item
          v-if="$props.parentCategory.stock_type == 'fabric'"
          :type="'Season (en)'"
          :name="product.season_en"
          :editProperty="'season_en'"
          :productId="product.productId"
          meta="true"
        ></product-edit-item>
      </div>
      <hr style="width: 100%" />
      <div>
        <h3>Images</h3>
        <strong>
          Please use an image that has an aspect ratio of
          <br />
          {{
            parentCategory.stock_type == "fabric"
              ? "1 : 1.27 (W : H) - Example: 350x520"
              : "1 : 1 (W : H) - Example: 350x350"
          }}
          <br />
          Ignoring this may cause distortion of the image on the website
        </strong>
        <div v-if="parentCategory.stock_type != 'product'">
          <div class="row">
            <div class="col-md-3">
              <EditImage
                :imgSrc="product.images[0].img"
                title="Main Image"
                meta="image"
                :productId="product.productId"
              ></EditImage>
            </div>
            <div class="col-md-3">
              <EditImage
                :imgSrc="product.images[1].img"
                title="Yaka image"
                meta="image_2"
                :productId="product.productId"
              ></EditImage>
            </div>
            <div class="col-md-3">
              <EditImage
                :imgSrc="product.images[2].img"
                title="Zarzour image"
                meta="image_3"
                :productId="product.productId"
              ></EditImage>
            </div>
            <div class="col-md-3">
              <EditImage
                :imgSrc="product.images[3].img"
                title="Akmam image"
                meta="image_4"
                :productId="product.productId"
              ></EditImage>
            </div>
          </div>
        </div>
        <div v-else>
          <EditImage
            :imgSrc="product.images[0].img"
            title="Main Image"
            meta="image"
            :productId="product.productId"
          ></EditImage>
        </div>
      </div>
      <div class="product-tags">
        <hr style="width: 100%" />
        <h3>Product Tags</h3>
        <div v-if="editTags">
          <b-form-checkbox
            v-model="product.tags.isBestSeller"
            name="check-button"
            switch
            >Best Seller</b-form-checkbox
          >
          <b-form-checkbox
            v-model="product.tags.isRecommended"
            name="check-button"
            switch
            >Recommended</b-form-checkbox
          >
          <b-form-checkbox
            v-model="product.tags.isLatest"
            name="check-button"
            switch
            >Latest</b-form-checkbox
          >
          <button class="btn btn-primary" v-if="loadingEditTags" disabled>
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            Loading..
          </button>
          <button class="btn btn-primary" @click="ApplyEditTags" v-else>
            Apply
          </button>
        </div>
        <div v-else>
          <p>Best Seller: {{ product.tags.isBestSeller }}</p>
          <p>Recommended: {{ product.tags.isRecommended }}</p>
          <p>Latest: {{ product.tags.isLatest }}</p>
          <button class="btn btn-primary" @click="openTagEdit">
            Edit Tags
          </button>
        </div>
      </div>
      <div v-if="parentCategory.stock_type == 'product'">
        <h3>Product Stock</h3>
        <div v-if="editStock">
          <input type="number" v-model="product.stock_amount" v-if="!options.length || options[0].quantity === null "/>
          <div
            class="card p-2 m-2"
            v-if="
              parentCategory &&
              parentCategory.stock_type === 'product'
            "
          >
            <div class="col-md-12 text-right" v-if="options.length < 1">
              <span class="p-2">
                <i
                  class="fas fa-plus-circle"
                  @click="addOption()"
                  >Add options Stock fields</i
                >
              </span>
            </div>
            <div
              class="form-group"
              v-for="(input, k) in options"
              :key="k"
            >
              <div class="row">
                <div class="col-md-3" v-if="parentCategory && input.color &&
                        parentCategory.filterTitle != 'كل الجزم'">
                  <label>Color</label>
                  <select class="form-control" v-model="input.color.id">
                    <option
                      v-for="fabric in fabrics"
                      :key="fabric.id"
                      :value="fabric.id"
                    >
                      {{ fabric.name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-3" v-if="parentCategory &&
                        parentCategory.filterTitle == 'كل الجزم'">
                  <label>Shoes Color</label>
                  <select class="form-control" v-model="input.shoesColor.id">
                    <option
                      v-for="shoeColor in shoesColors"
                      :key="shoeColor.id"
                      :value="shoeColor.id"
                    >
                      {{ shoeColor.name_en }}
                    </option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label>Size Name</label>
                  <select class="form-control" v-model="input.size.id">
                    <option
                      v-for="size in sizes"
                      :key="size.id"
                      :value="size.id"
                    >
                      {{ size.name_en }}
                    </option>
                  </select>
                </div>
                <div
                  class="col-md-3"
                  v-if="
                    parentCategory &&
                    parentCategory.filterTitle == 'كل التصاميم'
                  "
                >
                  <label>fabric</label>
                  <select class="form-control" v-model="input.fabric.id">
                    <option
                      v-for="fabric in fabrics_stocks"
                      :key="fabric.id"
                      :value="fabric.id"
                    >
                      {{ fabric.name_en }}
                    </option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label> Quantity</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="input.quantity"
                  />
                </div>
                <div class="col-md-12 text-right">
                  <span class="p-2">
                    <i
                      class="fas fa-minus-circle"
                      @click="removeOption(k)"
                      v-show="k || (!k && options.length > 1)"
                      >Remove</i
                    >
                    <i
                      class="fas fa-plus-circle"
                      @click="addOption(k)"
                      v-show="k == options.length - 1"
                      >Add fields</i
                    >
                  </span>
                </div>
              </div>
            </div>
          </div>
          <button class="btn btn-primary" @click="ApplyEditStock">
            Confirm changes
          </button>
        </div>
        <div v-else>
          <p>{{ product.stock_amount }}</p>
          <button class="btn btn-primary" @click="openStockEdit">
            Edit Stock
          </button>
        </div>
      </div>
      <div v-if="parentCategory.stock_type == 'fabric'">
        <div class="product-colors">
          <hr style="width: 100%" />
          <h2>Product Fabrics</h2>
          <div v-if="product.colors.length > 0">
            <div
              v-for="color in product.colors"
              :key="color.id"
              class="product-color"
            >
              <div v-if="color.id === active_color" class="product-color__edit">
                <form>
                  <p>Edit color {{ color.name }}</p>

                  <input type="file" accept="image/*" id="new-color-image" />
                  <span>Default?</span>
                  <input
                    type="checkbox"
                    :value="color.id"
                    @input="checkSelectedFabric($event, color.id)"
                  />

                  <button
                    class="btn btn-primary"
                    v-if="loadingUpdateProductFabric"
                    disabled
                  >
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Loading
                  </button>

                  <button
                    class="btn btn-primary"
                    @click.prevent="handleSubmitImage(color.id)"
                    v-else
                  >
                    Submit New Edits
                  </button>
                  <button
                    class="btn btn-success"
                    @click.prevent="cancelFabricEdit()"
                  >
                    Cancel
                  </button>
                </form>
              </div>
              <div v-else class="product-color__view">
                <div class="row">
                  <div class="col-md-4">
                    <p>Color Name: {{ color.name }}</p>
                  </div>
                  <div class="col-md-8">
                    <p>Product Image in this fabric</p>
                    <img :src="color.productImg" :alt="color.name" />
                  </div>
                </div>
                <div class="product-color__actions">
                  <button
                    class="btn btn-success"
                    @click="toggleActiveColor(color.id)"
                  >
                    <i class="far fa-edit"></i>
                  </button>
                  <button
                    class="btn btn-danger"
                    @click="deleteProductColor(color.id)"
                  >
                    <i class="far fa-trash-alt"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div v-else>no fabric for this product</div>
        </div>
        <div>
          <button class="btn btn-danger" @click="toggleColorMode">
            {{ !add_color_mode ? "Add Fabric for product" : "Cancel" }}
          </button>
          <div class="alert alert-success" v-show="adding_success" role="alert">
            Success
          </div>

          <div v-if="add_color_mode">
            <form>
              <div class="add-color">
                <label for>
                  Select Color
                  <select name id class="form-control" v-model="selected_color">
                    <option
                      v-for="color in colors"
                      :key="color.id"
                      :value="color"
                      :disabled="product.colors.find((i) => i.id === color.id)"
                    >
                      {{ color.name }}
                    </option>
                  </select>
                </label>
                <label>
                  Select Product image in this color
                  <input type="file" accept="image/*" id="color-image" />
                </label>
                <div class="d-flex justify-content-center align-items-center">
                  <span>Default:</span>
                  <input type="checkbox" v-model="default_color" class="ml-2" />
                </div>
                <button
                  class="btn btn-primary"
                  v-if="loadingAddProductFabric"
                  disabled
                >
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Loading
                </button>
                <button
                  class="btn btn-primary"
                  @click.prevent="handleSubmitColor"
                  v-else
                >
                  Confirm
                </button>
                <div
                  class="alert alert-danger"
                  role="alert"
                  v-if="errorAddingFabric.length > 0"
                >
                  <p v-for="(error, index) in errorAddingFabric" :key="index">
                    {{ error }}
                  </p>
                </div>
              </div>
            </form>
          </div>
        </div>
        <hr style="width: 100%" />
        <h1>All Product's Accessories</h1>
        <div
          class="product-accessories"
          v-for="(cat, index) in accessories"
          :key="index"
        >
          <div
            v-if="
              (accessoryEditMode && cat.children.length) ||
              (!accessoryEditMode &&
                cat.children.length &&
                cat.children.find((catI) => {
                  return product.accessories.find((prodI) => {
                    return prodI.id == catI.id;
                  });
                }))
            "
          >
            <h2>Product {{ cat.category.name_en }}</h2>

            <!--  -->
            <div v-if="accessoryEditMode">
              <div class="row">
                <div class="col-md-8">
                  <select class="form-control" multiple>
                    <option
                      v-for="accessory in cat.children"
                      :key="accessory.id"
                      :value="accessory"
                      @click="addAccessory(accessory, cat.category)"
                    >
                      {{ accessory.name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-4">
                  <h3>Selected {{ cat.category.name_en }}</h3>

                  <div class="row">
                    <div
                      :class="
                        cat.children.findIndex((j) => {
                          return j.id == accessory.id;
                        }) > -1
                          ? 'col-sm-2'
                          : 'hidden'
                      "
                      v-for="accessory in resultAccessories"
                      :key="accessory.id"
                    >
                      <div
                        v-if="
                          cat.children.findIndex((j) => {
                            return j.id == accessory.id;
                          }) > -1
                        "
                      >
                        <div
                          class="accessory-item"
                          :class="{ selected: isAccDefault(accessory.id) }"
                          @click="changeDefaultAccessory(accessory.id)"
                        >
                          <!-- <span>{{accessory.name}}</span> -->
                          <img :src="accessory.img" :alt="accessory.name" />
                          <button
                            class="btn btn-danger accessory-item__delete"
                            @click.stop="deleteAccessory(accessory.id)"
                          >
                            X
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <button class="btn btn-primary" @click="handleSubmitAccessory">apply</button> -->
            </div>
            <div v-else>
              <div v-if="product.accessories.length > 0">
                <div class="row" v-if="accessories">
                  <div
                    class="col-sm-2"
                    v-for="accessory in product.accessories.filter((i) => {
                      return (
                        cat.children.findIndex((j) => {
                          return j.id == i.id;
                        }) > -1
                      );
                    })"
                    :key="accessory.id"
                  >
                    <div
                      class="accessory-item"
                      :class="{ selected: isAccDefault(accessory.id) }"
                    >
                      <!-- <span>{{accessory.name}}</span> -->
                      <img :src="accessory.img" :alt="accessory.name" />
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <p>no accessories now</p>
              </div>
              <!-- <button class="btn btn-primary" @click="toggleEditAccessory">add more</button> -->
            </div>
          </div>
        </div>
        <!--  -->
        <button
          v-if="accessoryEditMode"
          class="btn btn-primary"
          @click="handleSubmitAccessory"
        >
          Apply changes
        </button>
        <button
          v-if="!accessoryEditMode"
          class="btn btn-primary"
          @click="toggleEditAccessory"
        >
          Edit/Add accessories
        </button>
        <div class="product-betanas">
          <hr style="width: 100%" />
          <h2>Product betanas</h2>
          <div v-if="betanaEditMode">
            <div class="row">
              <div class="col-md-8">
                <div class="autocomplete-container__input">
                  <select class="form-control" multiple>
                    <option
                      v-for="betana in betanas"
                      :key="betana.id"
                      :value="betana"
                      @click="addBetana(betana)"
                    >
                      {{ betana.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <h3>Selected Betanas</h3>

                <div class="row">
                  <div
                    class="col-sm-2"
                    v-for="betana in resultBetanas"
                    :key="betana.id"
                  >
                    <div
                      class="betana-item"
                      :class="isBetanaDefault(betana.id) ? 'selected' : ''"
                      @click="changeDefaultBetana(betana.id)"
                    >
                      <!-- <span>{{betana.name}}</span> -->
                      <img :src="betana.img" :alt="betana.name" />
                      <button
                        class="btn btn-danger betana-item__delete"
                        @click.stop="deleteBetana(betana.id)"
                      >
                        X
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <button class="btn btn-primary" @click="handleSubmitBetana">
                apply
              </button>
            </div>
          </div>
          <div v-else>
            <div v-if="product.betanas.length > 0">
              <div class="row">
                <div
                  class="col-sm-2"
                  v-for="betana in product.betanas"
                  :key="betana.id"
                >
                  <div
                    class="betana-item"
                    :class="{ selected: betana.default }"
                  >
                    <!-- <span>{{betana.name}}</span> -->
                    <img :src="betana.img" :alt="betana.name" />
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <p>no betanas now</p>
            </div>
            <button class="btn btn-primary" @click="toggleEditBetana">
              add more
            </button>
          </div>
        </div>
      </div>
    </div>
    <hr style="width: 100%" />
    <div v-if="product.category && !edit_category">
      <h2>Product Category</h2>
      <p>{{ product.category.name }}</p>
      <button class="btn btn-primary" @click="handleToggleCategoryEdit">
        Edit Product Category
      </button>
    </div>
    <div v-else-if="!product.cateogry || edit_category">
      <div class="product__category">
        <p>Select Product Categroy:</p>
        <div
          class="alert alert-danger"
          role="alert"
          v-if="categoryErrors.length > 0"
        >
          <p v-for="(error, index) in categoryErrors" :key="index">
            {{ error }}
          </p>
        </div>
        <div class="row">
          <select class="form-control col-md-6" v-model="selected_cat" disabled>
            <option
              v-for="category in categories"
              :key="category.categoryId"
              :value="category"
            >
              {{ category.filterTitle }}
            </option>
          </select>
          <select
            class="form-control col-md-6"
            v-model="selected_sub"
            v-if="selected_cat"
          >
            <option
              v-for="category in selected_cat.subCategory"
              :key="category.categoryId"
              :value="category"
            >
              {{ category.name }}
            </option>
          </select>
        </div>
      </div>
      <button
        class="btn btn-primary"
        v-if="loadingEditProductCategory"
        disabled
      >
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
        Loading
      </button>

      <button class="btn btn-primary" @click="handleEditCategory" v-else>
        Apply
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { getCookie } from "../../cookie.js";
import ProductEditItem from "./ProductEditItem.vue";
import EditImage from "./EditImage.vue";
import { herokuUrl } from "../../apiConfig";
import logOut from "../../scripts/utils";

export default {
  data() {
    return {
      loading: false,
      categoryErrors: [],
      errors: [],
      error: null,
      // error_title_en: null,
      // error_title: null,
      // error_sub_title_en: null,
      // error_sub_title: null,
      // error_price: null,
      // error_sale_price: null,
      add_color_mode: false,
      colors: [],
      selected_color: {},
      adding_success: false,
      active_color: null,
      edit_category: false,
      selected_cat: null,
      selected_sub: null,
      accessories: [],
      betanas: [],
      accessoryEditMode: false,
      betanaEditMode: false,
      resultAccessories: [],
      resultBetanas: [],
      default_accessory: null,
      default_betana: null,
      default_color: false,
      default_fabric: null,
      loadingUpdateProductFabric: false,
      loadingAddProductFabric: false,
      loadingEditProductCategory: false,
      editTags: false,
      loadingEditTags: false,
      editStock: false,
      loadingEditStock: false,
      errorAddingFabric: [],
      calssificationsOfAccessories: {},
      options: [],
      fabrics: [],
      sizes: [],
      fabrics_stocks: [],
      shoesColors: [],
    };
  },
  props: ["product", "categories", "parentCategory"],
  components: {
    ProductEditItem,
    EditImage,
  },
  methods: {
    getShoesColors: function () {
      this.loading = true;
      return Promise.all([
        axios.get(`${herokuUrl}/shoes_colors`, null, {
          headers: {
            Authorization: getCookie("user"),
          },
        }),
      ])
        .then((res) => {
          console.log(res[0].data["colors"]);
          this.shoesColors = res[0].data["colors"];
          this.loading = false;
        })
        .catch((err) => {
            console.log(err);
        });
    },
    getColors() {
      axios
        .post(`${herokuUrl}/dashboard/colors`)
        .then((response) => {
          console.log('colorsssssssss',response.data.colors);
          if (response.data.status) {
            this.loading = false;
            this.fabrics = response.data.colors;
          } else {
            this.loading = false;
            this.error = response.data.message;
          }
        })
        .catch((err) => {
          if (err.response.status == 401) {
            logOut();
          } else {
            this.loading = false;
            this.error = err;
          }
        });
    },
    getfabrics: function () {
      this.loading = true;
      return Promise.all([
        axios.get(`${herokuUrl}/fabrics`, null, {
          headers: {
            Authorization: getCookie("user"),
          },
        }),
      ])
        .then((res) => {
          console.log(res);
          this.fabrics_stocks = res[0].data["fabrics"];
          this.loading = false;
        })
        .catch((err) => {
            console.log(err);
        });
    },
    getsizes: function () {
      this.loading = true;
      return Promise.all([
        axios.get(`${herokuUrl}/sizes`, null, {
          headers: {
            Authorization: getCookie("user"),
          },
        }),
      ])
        .then((res) => {
          console.log(res);
          this.sizes = res[0].data["sizes"];
          this.loading = false;
        })
        .catch((err) => {
            console.log(err);
        });
    },
    //product stock options
    addOption() {
      this.options.push({
        color: {id:""},
        size: {id:""},
        fabric: {id:""},
        shoesColor: {id: ""},
        quantity: "",
      });
      console.log(this.options);
    },

    removeOption(index) {
      this.options.splice(index, 1);
    },
    /* eslint-disable no-console */
    isBetanaDefault(betanaId) {
      if (this.default_betana && this.default_betana == betanaId) return true;
      else if (this.default_betana && this.default_betana != betanaId)
        return false;
      else {
        let foundBetana = this.resultBetanas.find((xxi) => {
          return betanaId == xxi.id;
        });
        return foundBetana.default;
      }
    },
    ApplyEditStock() {
      this.loadingEditStock = true;
      if(this.options.length > 0){
        this.product.stock_amount = 0;
        this.options.map((i) => {
          this.product.stock_amount += Number(i.quantity);
        })
      }
      axios
        .post(
          // `${herokuUrl}/dashboard/edit-product`,
          `${herokuUrl}/dashboard/edit-product-amount`,

          {
            productId: this.product.productId,
            amount: this.product.stock_amount,
            options:this.options
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: getCookie("user"),
            },
          }
        )
        .then((response) => {
          this.loadingEditStock = false;
          if (response.data.status) {
            this.editStock = false;
          } else {
            this.errors.push(response.data.message);
          }
        })
        .catch((err) => {
          if (err.response.status == 401) {
            logOut();
          } else {
            this.errors.push(err);
          }
        });
    },
    openStockEdit() {
      this.editStock = true;
    },
    openTagEdit() {
      this.editTags = true;
    },
    ApplyEditTags() {
      this.loadingEditStock = true;
      axios
        .post(
          `${herokuUrl}/dashboard/edit-product`,
          {
            productId: this.product.productId,
            is_last: this.product.tags.isLatest,
            is_best_seller: this.product.tags.isBestSeller,
            is_recommended: this.product.tags.isRecommended,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: getCookie("user"),
            },
          }
        )
        .then((response) => {
          this.loadingEditTags = false;
          if (response.data.status) {
            this.editTags = false;
          } else {
            if (response.data.message) this.errors.push(response.data.message);
          }
        })
        .catch((err) => {
          if (err.response.status == 401) {
            logOut();
          } else {
            this.errors.push(err);
          }
        });
    },
    getProductColorList() {
      axios
        .post(`${herokuUrl}/dashboard/colors`, { language: 1 })
        .then((response) => {
          if (response.data.status) {
            this.colors = response.data.colors;
          } else {
            this.err = "Can't load colors";
          }
        })
        .catch((err) => {
          if (err.response.status == 401) {
            logOut();
          } else {
            this.error = err.data;
          }
        });
    },
    toggleEditTitle(editable) {
      this[editable] = true;
    },
    updateInput(value, type) {
      this.product[type] = value;
    },
    toggleColorMode() {
      this.add_color_mode = !this.add_color_mode;
      this.default_color = false;
      this.selected_color = null;
    },
    toggleActiveColor(id) {
      this.active_color = id;
    },
    toggleEditAccessory() {
      this.accessoryEditMode = true;
    },
    toggleEditBetana() {
      this.betanaEditMode = true;
    },
    cancelFabricEdit() {
      this.active_color = null;
    },

    handleSubmitImage(id) {
      var bodyFormData = new FormData();

      var colorImage = document.getElementById("new-color-image").files[0];
      bodyFormData.append("colorId", id);
      bodyFormData.append("productId", this.product.productId);
      bodyFormData.append("default", this.default_fabric == id ? true : false);
      bodyFormData.append("image", colorImage);
      this.loadingUpdateProductFabric = true;
      axios({
        method: "POST",
        url: `${herokuUrl}/dashboard/edit-product-color`,
        data: bodyFormData,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: getCookie("user"),
        },
      })
        .then((response) => {
          this.loadingUpdateProductFabric = false;
          if (response.data.status) {
            this.active_color = null;
            // this.$router.replace({ path: 'manage-product', query: { selectedOrderId:  this.product.productId} })
            // window.location.replace(window.location.origin + "/manage-product?selectedOrderId=" + this.product.productId)

            let updatedColor = this.product.colors.find(
              (color) => color.id === id
            );
            updatedColor.productImg = response.data.image;
          } else {
            this.errors.push("For files, large file upload is forbidden");
            this.errors.push(response.data.message);
          }
        })
        .catch((err) => {
          if (err.response.status == 401) {
            logOut();
          } else {
            // console.log(err);
            this.loadingUpdateProductFabric = false;
            this.errors.push(err);
            this.errors.push("For files, large file upload is forbidden");
          }
        });
    },
    deleteProductColor(id) {
      // var targetId = this.product.colors.findIndex(elem => elem.id === id);
      // console.log(targetId);
      if (window.confirm("Are you sure?")) {
        if (this.product.colors.length > 1) {
          // Delete this fabric
          axios
            .post(
              `${herokuUrl}/dashboard/delete-product-color`,
              { productId: this.product.productId, colorId: id },
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: getCookie("user"),
                },
              }
            )
            .then((response) => {
              if (response.data.status) {
                if (this.product.colors.length > 1) {
                  var splicedArr = this.product.colors.filter(
                    (elem) => elem.id !== id
                  );
                  this.product.colors = splicedArr;
                } else {
                  this.product.colors = [];
                }
                // this.$router.replace({ path: 'manage-product', query: { selectedOrderId:  this.product.productId} })
                // window.location.replace(window.location.origin + "/manage-product?selectedOrderId=" + this.productId)
              }
            })
            .catch((err) => {
              if (err.response.status == 401) {
                logOut();
              } else {
                console.log(err);
              }
            });
        } else {
          // Do nothing if there's only ONE fabric!
          alert(
            "You must have at least one fabric. \nAdd another fabric to delete this one"
          );
        }
      }
    },
    handleToggleCategoryEdit() {
      this.edit_category = true;
      this.selected_cat = this.$props.categories.find((i) => {
        return i.categoryId == this.$props.parentCategory.categoryId;
      }); //null;
      this.selected_sub = this.selected_cat.subCategory.find((i) => {
        return i.categoryId == this.$props.product.category.id;
      }); //null;
    },
    changeDefaultAccessory(id) {
      // console.log("calles")
      let classifications = Object.keys(this.calssificationsOfAccessories);
      let itsClassification = null;
      let foundIndex = -1;
      for (let m = 0; m < classifications.length; m++) {
        let i = classifications[m];
        foundIndex = this.calssificationsOfAccessories[String(i)].arr.findIndex(
          (j) => {
            return j.id == id;
          }
        );
        if (foundIndex >= 0) {
          itsClassification = String(i);
          break;
        }
      }
      this.calssificationsOfAccessories[
        itsClassification
      ].default_accessory = id;
      this.calssificationsOfAccessories = {
        ...this.calssificationsOfAccessories,
      };
      // this.default_accessory = id;
    },
    changeDefaultBetana(id) {
      this.default_betana = id;
    },
    handleEditCategory() {
      this.categoryErrors = [];
      if (!this.selected_cat)
        this.categoryErrors.push("Please add main Category");
      if (!this.selected_sub)
        this.categoryErrors.push("Please add sub Category");

      if (this.categoryErrors.length === 0) {
        this.loadingEditProductCategory = true;
        axios
          .post(
            `${herokuUrl}/dashboard/edit-product-category`,
            {
              productId: this.product.productId,
              categoryId: this.selected_sub.categoryId,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: getCookie("user"),
              },
            }
          )
          .then((response) => {
            this.loadingEditProductCategory = false;

            if (response.data.status) {
              this.edit_category = false;
              this.$emit("updateCurrentProduct", {
                id: this.selected_sub.categoryId,
                name: this.selected_sub.name,
              });
            } else {
              this.errors.push("For files, large file upload is forbidden");
              this.categoryErrors.push("error in adding category");
            }
          })
          .catch((err) => {
            if (err.response.status == 401) {
              logOut();
            } else {
              this.loadingEditProductCategory = false;
              this.categoryErrors.push(err);
              this.errors.push("For files, large file upload is forbidden");
            }
          });
      }
    },
    getAcessories() {
      axios
        .post(
          `${herokuUrl}/dashboard/selectableproducts/accessories`,
          { language: 1 },
          {
            headers: { Authorization: getCookie("user") },
          }
        )
        .then((response) => {
          if (response.data.status) {
            this.accessories = response.data.accessories;
          } else {
            this.error = "error in loading";
          }
        })
        .catch((err) => {
          if (err.response.status == 401) {
            logOut();
          } else {
            this.error = err;
          }
        });
    },
    getBetanas() {
      axios
        .post(
          `${herokuUrl}/dashboard/product/betanas`,
          { language: 1 },
          {
            headers: { Authorization: getCookie("user") },
          }
        )
        .then((response) => {
          if (response.data.status) {
            this.betanas = response.data.betanas;
          } else {
            this.error = "error in loading";
          }
        })
        .catch((err) => {
          if (err.response.status == 401) {
            logOut();
          } else {
            this.error = err;
          }
        });
    },
    addAccessory(accessory, categoryOfAcc) {
      this.calssificationsOfAccessories[categoryOfAcc.name_en]
        ? null
        : (this.calssificationsOfAccessories[categoryOfAcc.name_en] = {
            arr: [],
            default_accessory: null,
          });
      if (!this.resultAccessories.find((i) => i.id === accessory.id)) {
        // if (this.resultAccessories.length == 0) {
        //   this.default_accessory = accessory.id;
        // }

        if (
          this.calssificationsOfAccessories[categoryOfAcc.name_en].arr.length ==
          0
        ) {
          this.calssificationsOfAccessories[
            categoryOfAcc.name_en
          ].default_accessory = accessory.id;
        }
        this.calssificationsOfAccessories[categoryOfAcc.name_en].arr.push(
          accessory
        );
        this.calssificationsOfAccessories = {
          ...this.calssificationsOfAccessories,
        };
        this.resultAccessories.push(accessory);
      }
    },
    addBetana(betana) {
      if (!this.resultBetanas.find((i) => i.id === betana.id)) {
        if (this.resultBetanas.length == 0) {
          this.default_betana = betana.id;
        }
        this.resultBetanas.push(betana);
      }
    },
    deleteAccessory(id) {
      this.resultAccessories.splice(
        this.resultAccessories.findIndex((i) => i.id === id),
        1
      );

      let classifications = Object.keys(this.calssificationsOfAccessories);
      let itsClassification = null;
      let foundIndex = -1;
      for (let m = 0; m < classifications.length; m++) {
        let i = classifications[m];
        foundIndex = this.calssificationsOfAccessories[String(i)].arr.findIndex(
          (j) => {
            return j.id == id;
          }
        );
        if (foundIndex >= 0) {
          itsClassification = String(i);
          break;
        }
      }
      this.calssificationsOfAccessories[itsClassification].arr.splice(
        foundIndex,
        1
      );

      if (
        this.calssificationsOfAccessories[itsClassification]
          .default_accessory === id
      ) {
        this.calssificationsOfAccessories[itsClassification].arr.length
          ? (this.calssificationsOfAccessories[
              itsClassification
            ].default_accessory = this.calssificationsOfAccessories[
              itsClassification
            ].arr[0].id)
          : (this.calssificationsOfAccessories[
              itsClassification
            ].default_accessory = null);
      }
      this.calssificationsOfAccessories = {
        ...this.calssificationsOfAccessories,
      };

      // if (this.default_accessory === id) {
      //   this.default_accessory = this.resultAccessories[0].id;
      // }
    },
    deleteBetana(id) {
      this.resultBetanas.splice(
        this.resultBetanas.findIndex((i) => i.id === id),
        1
      );
      if (this.default_betana === id) {
        this.default_betana = this.resultBetanas[0].id;
      }
    },
    checkSelectedFabric(event, id) {
      /* eslint-disable no-console */
      console.log(event.target.checked, id);
      // event.target.checked == true
      //   ? (this.default_fabric = id)
      //   : (this.default_fabric = null);
      this.default_fabric = id;
    },
    handleSubmitColor() {
      this.errorAddingFabric = [];
      var bodyFormData = new FormData();
      if (!this.selected_color) {
        this.errorAddingFabric.push("no color selected");
      }
      const colorImage = document.getElementById("color-image").files[0];
      if (!colorImage) {
        this.errorAddingFabric.push("no image selected");
      }
      if (this.errorAddingFabric.length == 0) {
        bodyFormData.append("colorId", this.selected_color.id);
        bodyFormData.append("productId", this.product.productId);
        bodyFormData.append("image", colorImage);
        bodyFormData.append("default", this.default_color);
        this.loadingAddProductFabric = true;
        axios({
          method: "POST",
          url: `${herokuUrl}/dashboard/add-product-color`,
          // url: `http://localhost:5001/api/dashboard/add-product-color`,
          data: bodyFormData,
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: getCookie("user"),
          },
        })
          .then((response) => {
            this.loadingAddProductFabric = false;

            if (response.data.status) {
              this.default_color
                ? this.product.colors.map((i) => ({ ...i, default: false }))
                : null;
              this.default_color
                ? this.product.colors.push({
                    name: this.selected_color.name,
                    id: this.selected_color.id,
                    productImg: response.data.image,
                    default: true,
                  })
                : this.product.colors.push({
                    name: this.selected_color.name,
                    id: this.selected_color.id,
                    productImg: response.data.image,
                    default: false,
                  });
              this.add_color_mode = false;
              this.default_color = false;
              //   this.adding_success = true;
              //   setTimeout(() => {
              //     this.adding_success = false;
              //   }, 2000);
            } else {
              this.errors.push("For files, large file upload is forbidden");
              this.errorAddingFabric.push(response.data.message);
            }
          })
          .catch((err) => {
            if (err.response.status == 401) {
              logOut();
            } else {
              console.log(err);
              this.errorAddingFabric.push("Error in adding new fabric");
              this.errors.push("For files, large file upload is forbidden");
            }
          });
      }
    },
    handleSubmitAccessory() {
      axios
        .post(
          `${herokuUrl}/dashboard/add-product-accessories`,
          {
            // axios
            //   .post(
            //     `http://localhost:5001/api/dashboard/add-product-accessories`,
            //     {
            productId: this.product.productId,
            accessories: this.resultAccessories.map((i) => ({
              id: i.id,
              default: this.isAccDefault(i.id),
            })),
            // defaultId: this.default_accessory
          },
          {
            headers: {
              Authorization: getCookie("user"),
            },
          }
        )
        .then((response) => {
          if (response.data.status) {
            this.accessoryEditMode = false;
            this.product.accessories = this.resultAccessories.map((i) =>
              this.isAccDefault(i.id)
                ? { ...i, default: true }
                : { ...i, default: false }
            );
            this.default_betana = null;
          }
        })
        .catch((err) => {
          if (err.response.status == 401) {
            logOut();
          } else {
            console.log(err);
          }
        });
    },
    handleSubmitBetana() {
      axios
        .post(
          `${herokuUrl}/dashboard/add-product-betanas`,
          // `http://localhost:5001/api/dashboard/add-product-betanas`,
          {
            productId: this.product.productId,
            betanas: this.resultBetanas.map((i) => ({
              id: i.id,
            })),
            defaultId: this.default_betana,
          },
          {
            headers: {
              Authorization: getCookie("user"),
            },
          }
        )
        .then((response) => {
          if (response.data.status) {
            this.betanaEditMode = false;
            this.product.betanas = this.resultBetanas.map((i) =>
              i.id === this.default_betana
                ? { ...i, default: true }
                : { ...i, default: false }
            );
            this.default_betana = null;
          }
        })
        .catch((err) => {
          if (err.response.status == 401) {
            logOut();
          } else {
            console.log(err);
          }
        });
    },
    findAcc(id) {
      let m = null;
      for (let o = 0; o < this.accessories.length; o++) {
        let i = this.accessories[o];
        // console.log( i , "class of o")
        let x = i.children.findIndex((j) => {
          return j.id == id;
        });
        if (x >= 0) {
          m = i;
          // console.log("find Acc x = ",x);
          // console.log("find Acc m = ",m);
          break;
        }
      }
      return m;
    },
    isAccDefault(id) {
      if (!this.accessories) {
        return false;
      }
      let classifications = Object.keys(this.calssificationsOfAccessories);
      let itsClassification = null;
      let foundIndex = -1;
      for (let m = 0; m < classifications.length; m++) {
        let i = classifications[m];
        foundIndex = this.calssificationsOfAccessories[String(i)].arr.findIndex(
          (j) => {
            return j.id == id;
          }
        );
        if (foundIndex >= 0) {
          itsClassification = String(i);
          break;
        }
      }
      // console.log("foundIndex ", foundIndex, " itsClass ", itsClassification);
      if (foundIndex >= 0 && itsClassification)
        return (
          this.calssificationsOfAccessories[itsClassification].arr[foundIndex]
            .id ==
          this.calssificationsOfAccessories[itsClassification].default_accessory
        );
      else {
        return false;
      }
    },
    getProductDetails(){
      this.product.options_stock.forEach(element => {
        if(element.quantity && element.quantity != null && element.quantity > 0){
          this.options.push(element);
        }
      });
    }

  },
  //
  created() {
    console.log(this.product);
    this.getShoesColors();
    this.getColors();
    this.getsizes();
    this.getfabrics();
    this.getProductDetails();
    this.getProductColorList();
    this.getAcessories();
    this.getBetanas();
    this.resultAccessories = this.product.accessories;
    this.resultBetanas = this.product.betanas;
    let fn = () => {
      if (this.accessories.length) {
        this.resultAccessories.forEach((i) => {
          if (this.findAcc(i.id)) {
            let m = this.findAcc(i.id).category.name_en;
            if (!this.calssificationsOfAccessories[m])
              this.calssificationsOfAccessories[m] = {
                arr: [],
                default_accessory: null,
              };
            this.calssificationsOfAccessories[m].arr.push(i);
            if (i.default)
              this.calssificationsOfAccessories[m].default_accessory = i.id;
          }
        });
        this.$forceUpdate();
      } else {
        setTimeout(fn, 200);
      }
    };
    fn();
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/_global.scss";
.product-color {
  background: #fff;
  border-radius: 10px;
  padding-bottom: 20px;
  margin-bottom: 20px;
  img {
    height: 300px;
  }
  &__actions {
    margin-top: 10px;
    button {
      cursor: pointer;
    }
  }
}
.add-color {
  display: flex;
  width: 100%;
  flex-direction: column;
  label {
    margin-bottom: 20px;
  }
}
.accessory-item,
.betana-item {
  cursor: pointer;
  position: relative;
  img {
    width: 100%;
  }
  &__delete {
    width: 50%;
    font-size: 5px;
    position: absolute;
    left: 50%;
    top: 0;
    bottom: 50%;
    padding: 0;
    margin: 0;
  }
}
.selected {
  border: 2px solid black;
}
</style>
